import styled from "@emotion/styled";

export const ContModal = styled.div`
    width:100%;
    height:100%;
    position:absolute;
    z-index:999;
    display:flex;   
    flex-flow:column wrap;   
    justify-content:center;   
    align-items:center;
    background: linear-gradient( to bottom, rgba(0,0,0,.6), rgba(0,0,0,.2));
    transform-styles:preserve-3d;
    perspective:600px;
    
    .mimodal{
        border-radius:10px;
        width:95%;
        max-width:600px;
        padding:.5em;
        background:white;
        height:50ox;
        border:4px solid ${props => Semaforo[props.tipo] };
        box-shadow: 0 1px 5px rgba(0,0,0,.2);
    }
    .mimodal-modal2{
        border-radius:10px;
        width: 470px;
        max-width:600px;
        padding:.5em;
        background:white;
        height:50ox;
        box-shadow: 0 1px 5px rgba(0,0,0,.2);
    }
    .mimodal-modalTiempo{
        position: absolute;
        width: min(60%, 565px);
        height: min(75%, 600px)
    }
    .txtTiempo{
        position: absolute;
        width: 396px;
        height: 78px;
        font-family: 'Kanit';
        font-style: normal;
        font-weight: 600;
        font-size: 26px;
        line-height: 39px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #000000;
        margin: auto;
        flex-direction: column;
        width: auto;
        padding: 0px 50px;
    }
    @media (max-width: 620px) {
        .mimodal-modalTiempo{
            width: calc(100% - 35px);
            height: calc(100% - 25px)
        }
    }
    @media (max-width: 320px) {
        .mimodal-modalTiempo{
            width: calc(100% - 5px);
        }
        .txtTiempo{
            padding: 0;
        }
    }
    @media (max-aspect-ratio: 1/2) and (min-width: 300px) {
        .mimodal-modalTiempo{
            height: 650px;
        }
    }
    @media (min-aspect-ratio: 8/11) and (min-width: 300px) {
        .mimodal-modalTiempo{
            height: 650px;
        }
    }
    .message-modal2{
        left: 10.79%;
        right: 10.26%;
        top: 91px;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: #5C5B5C;
    }
    .message2-modal2{
        left: 10.79%;
        right: 10.26%;
        top: 91px;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #5C5B5C;
    }
    h3{
       color:#5B6670;
       font-size:1.2em;
    }
    .icono{
        width:70px;
        margin:1em auto;
        
        img{
        width:100%;
        heightt:auto;
        display:block;
        }
    }
    .icono-warning-modal2{
        color: #FFD100;
        font-size: 50px;
        width: 100%;
        text-align: center;
        margin: 20px 0;
    }
    .iconoTiempo{
        width: -webkit-fill-available;
        display: flex;
        justify-content: center;
    }
    .imgTiempo{
        width: 200px;
        margin: auto;
        padding: 0px;
        text-align: center;
    }
    
    .close{
        position:absolute;
        top:10px;
        right:10px;
        width:30px;
        cursor:pointer;
        z-index:99;
        
        &:focus{
            outline:none;
        }
    }
`;
export const Semaforo = {
    danger: "#FF6660",
    success: "#67C940",
    info: "#40A8E6",
    warning: "#FFD100",
};
